import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import DownloadButton from '../../../molecules/DownloadButton';
import { Grid, Typography } from '@mui/material';
var OfferLists = function () {
    var t = useTranslation().t;
    var dateStr = format(new Date(), 'yyyyMMdd');
    return (React.createElement(Grid, { container: true, spacing: 3 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "h2", component: "h2", gutterBottom: true }, t('admin.exportCsv.offerList.title'))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(DownloadButton, { title: t('admin.exportCsv.labels.downloadButton'), path: "/api/admin/export_csv/offer_lists", downloadFilename: "offer_lists_".concat(dateStr, ".csv"), size: "medium" }))));
};
export default OfferLists;
